import React, { useRef, useState } from "react";

//Import CSS
import "../../../App.less";

//Import our Assets
import video from "../../../assets/TenderFish.mp4";
import logo from "../../../assets/MARFish.png";

//Import Mui
import { Button } from "@mui/material";
import MuiTextField from "../../controls/MuiTextField";
import Alert from "../../controls/MuiSnackbarAlert";

//Import React Router Dom
import { NavLink, useNavigate } from "react-router-dom";

//Import api
// import api from "../../api/config";

//Import Reduxtoolkit
import { useDispatch } from "react-redux";

//Import from loginSlice
import { validateUserCredentials, getSignInUserFromServer } from "./loginSlice";
import { unwrapResult } from "@reduxjs/toolkit";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // useState
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  // const [error, setError] = useState("");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  // End useState

  // useRef
  const userNameRef = useRef(null);
  const passwordRef = useRef(null);
  // End useRef

  const handleLogin = async () => {
    let trimmedUserName = userName.trim();
    let trimmedPassword = password.trim();

    if (trimmedUserName === "" || trimmedPassword === "") {
      setNotify({
        isOpen: true,
        message: "Invalid Username/Password",
        severity: "error",
      });
    } else {
      let userInfo = { userName: trimmedUserName, password: trimmedPassword };

      try {
        // Validate user credentials
        const result = await dispatch(validateUserCredentials(userInfo)).then(
          unwrapResult
        );

        if (result.flag === 1) {
          setNotify({
            isOpen: true,
            message: result.message,
            severity: "success",
          });

          // Fetch sign-in user from server
          const userResponse = await dispatch(getSignInUserFromServer()).then(
            unwrapResult
          );

          // If token is invalid or there's an authorization issue
          if (userResponse.status === "error") {
            setNotify({
              isOpen: true,
              message: "Authorization failed. Please log in again.",
              severity: "error",
            });
          } else {
            // Navigate to dashboard or handle successful login
            setTimeout(() => {
              navigate("/dashboard");
            }, 1000);
          }
        } else {
          setNotify({
            isOpen: true,
            message: result.message,
            severity: "error",
          });
        }
      } catch (error) {
        console.error("Error occurred: ", error);
        const errorMessage = error.message || JSON.stringify(error);
        setNotify({
          isOpen: true,
          message: `An error occurred: ${errorMessage}`,
          severity: "error",
        });
      }
    }
  };

  return (
    <div className="loginPage flex">
      <div className="container flex">
        <Alert notify={notify} setNotify={setNotify} />
        <div className="videoDiv">
          <video src={video} autoPlay muted loop></video>

          <div className="textDiv">
            <h2 className="title">Create and Sell Extraordinary Products</h2>
            <p>Adopt the Peace of Nature!</p>
          </div>
          <div className="footerDiv flex">
            <span className="text"> Don't have an account?</span>
            {/* to="register" */}
            <NavLink className="btn">Sign Up</NavLink>
          </div>
        </div>

        <div className="formDiv flex">
          <div className="headerDiv">
            <img src={logo} alt="Logo Image"></img>
            <h3>Welcome Back!</h3>
          </div>

          {/* <form className="form grid" onSubmit={handleLogin}> */}
          {/* {error.length ? <span className="showMessage">{error}</span> : null} */}
          <div className="inputDiv">
            <MuiTextField
              id="username"
              label="Username *"
              onChange={(e) => {
                setUserName(e.target.value);
              }}
              value={userName}
              inputRef={userNameRef}
              autoComplete="off"
              autoFocus
            />
          </div>
          <div className="inputDiv">
            <MuiTextField
              id="password"
              type="password"
              label="Password *"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              inputRef={passwordRef}
              autoComplete="current-password"
              onKeyDown={(e) => {
                if (e.key.toLowerCase() === "home") userNameRef.current.focus();
              }}
            />
          </div>
          {/* onClick={handleLogin} */}
          {/* <button className="btn flex">
            <span>Login</span>
          </button> */}
          <Button
            style={{
              backgroundColor: "#ff771d",
              textTransform: "none",
              margin: "auto",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "'Roboto', sans-serif",
            }}
            variant="contained"
            size="small"
            fullWidth
            onClick={handleLogin}
          >
            Login
          </Button>

          <span className="forgotPassword">
            Forgot your Password?
            {/* to="/passwordreset" */}
            <NavLink to="/passwordreset"> Click Here</NavLink>
          </span>
          {/* </form> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
